import React from "react";
import styles from "./ApplicationButton.module.scss";
import ApplicationBtnOut from "./ApplicationBtnOut";
import ApplicationBtnIn from "./ApplicationBtnIn";
import ApplicationBtnCenter from "./ApplicationBtnCenter";
import ApplicationBtnCenterApplied from "./ApplicationBtnCenterApplied";
import { sendEventTracking } from "../../utils/GeneralUtils";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  isUserLoggedIn: boolean;
  handler?: () => void;
  isApplied?: boolean;
};
const ApplicationButton: React.FC<Props> = ({
  isUserLoggedIn,
  handler,
  isApplied,
}) => {
  return (
    <>
      {isUserLoggedIn ? (
        <button
          type="button"
          className={
            isApplied
              ? `${styles["f-applicationBtn"]}`
              : `${styles["f-applicationBtn"]} ${styles["btn-active"]}`
          }
          onClick={!isApplied ? handler : undefined}
        >
          <div className={styles["f-applicationBtn__out"]}>
            <ApplicationBtnOut />
          </div>
          <div className={styles["f-applicationBtn__in"]}>
            <ApplicationBtnIn />
          </div>
          <div className={styles["f-applicationBtn__center"]}>
            {isApplied ? (
              <ApplicationBtnCenterApplied />
            ) : (
              <ApplicationBtnCenter />
            )}
          </div>
        </button>
      ) : (
        <div className={`${styles["f-applicationBtn"]} ${styles["notLogin"]}`}>
          <div className={styles["f-applicationBtn__out"]}>
            <ApplicationBtnOut />
          </div>
          <div className={styles["f-applicationBtn__in"]}>
            <ApplicationBtnIn />
          </div>
          <div className={styles["f-applicationBtn__center"]}>
            <ApplicationBtnCenter />
          </div>
          <span className={styles["f-applicationBtn__notes"]}>
            ※会員限定の機能です
          </span>
          <SonicLink
            to="/register"
            className={styles["f-applicationBtn__to-regist"]}
            onClick={() =>
              sendEventTracking("click", "projectDetail", "register")
            }
          >
            会員登録はこちら
          </SonicLink>
        </div>
      )}
    </>
  );
};

export default ApplicationButton;
